import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/cross.svg'
import _imports_1 from '@/assets/img/plus.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "d-flex align-items-end justify-content-between" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "text-center mt-5" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Select a provider",
          text: "Select a provider"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_localized_text, {
              type: "label",
              localizedKey: "Layer",
              text: "Layer"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.layer), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_localized_text, {
              type: "label",
              localizedKey: "Production Phase",
              text: "Production Phase"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.productionPhase), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_form_field, {
                type: "select",
                labelKey: "Provider",
                labelValue: "Provider",
                placeholderKey: "Select an existing provider...",
                placeholderValue: "Select an existing provider...",
                list: _ctx.localAvailableProvidersTextID,
                modelValue: _ctx.model.provider.identifier,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.provider.identifier) = $event)),
                class: "w-100"
              }, null, 8, ["list", "modelValue"]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary ms-2 mb-4",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addNewProvider()))
              }, _hoisted_16)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Confirm",
            text: "Confirm"
          })
        ], 8, _hoisted_18)
      ])
    ])
  ]))
}